import { render, staticRenderFns } from "./IconRewindSolid.vue?vue&type=template&id=4cb7a5df"
import script from "./IconRewindSolid.vue?vue&type=script&lang=js"
export * from "./IconRewindSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports